import { View } from "./view";
import { useViewModel } from "./viewModel";

export default function BookingDetail() {
  const viewModel = useViewModel();
  return <View {...viewModel} />;
}
